import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { VehicleCoordinate } from '../types/VehicleCoordinate';

interface Address {
  amenity: string;
  road: string;
  neighbourhood: string;
  town: string;
  city_district: string;
  city: string;
  state: string;
  ISO3166_2_lvl4: string;
  postcode: string;
  country: string;
  country_code: string;
}

interface NominatimResponse {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  class: string;
  type: string;
  place_rank: number;
  importance: number;
  addresstype: string;
  name: string;
  display_name: string;
  address: Address;
  boundingbox: [string, string, string, string];
}

export const nominatimApi = createApi({
  reducerPath: 'nominatimApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `https://nominatim.openstreetmap.org`,
  }),
  endpoints: builder => ({
    getLocation: builder.query<NominatimResponse, Pick<VehicleCoordinate, 'latitude' | 'longitude'>>({
      query: arg => ({
        url: `/reverse?lat=${arg.latitude}&lon=${arg.longitude}&format=json&addressdetails=1`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetLocationQuery } = nominatimApi;
